import React from "react";

export const Message = ({ type, message }) => (
  <div className={"flashmsg flashmsg-" + type}>
    <p>{message}</p>
  </div>
);
